import React, { useState, memo } from 'react';
import { Link } from 'gatsby';
import { useInView } from 'react-intersection-observer';
import { transformPrice } from '../../../../utils/formattes';

const OtherGame = ({ games, currentLocale, translate, closeMenu }) => {
  const [currentInView, setCurrentInView] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0,
  });
  if (inView && !currentInView) {
    setCurrentInView(true);
  }
  console.log(currentLocale)
  return (
    <ul className="submenu">
      {
            games?.map((element) => (
              <li key={element.slug}>
                <Link
                  to={`${currentLocale}/play/${element.slug}`}
                  onClick={closeMenu}
                  className="link-item"
                  ref={ref}
                  style={{
                    backgroundImage: currentInView && element.ballImgUrl ?  `url(${element.ballImgUrl})`  : null,
                  }}
                >
                  <div
                    className="image-block"
                    style={{
                      backgroundImage: currentInView && element.logoImgUrl ? `url(${element.logoImgUrl})` : null,
                    }}
                  />
                  <div className="text-block">
                    <div className="info">
                      <div className="game-title">
                        {element.lotteryTitle}
                      </div>
                      <div className="price">
                        {transformPrice(element.jackpot, 'amountWithCurrency')}
                      </div>
                      <div className="play-now">
                        {translate('Play Now')}
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))
        }
    </ul>
  );
};

export default memo(OtherGame);
